export {TiresInventoryModule} from './tiresInventoryModule';
